/**
 * @desc: 供应商-资料注册
 * @created: 2020/4/15
 * @author:yeungyifan
 * @version : v1.0
 */
import request from '@/plugins/http'

// 列表 - 条件查询
export const getSupplierRegisList = params => {
  return request.get('/supplier/list/entry', params)
}

// 获取供应商档案号
export const getId = params => {
  return request.get('/supplier/getRecordId', params)
}

// 新增表单
export const create = params => {
  return request.post('/supplier/entry', params, { json: true })
}

// 修改表单
export const update = params => {
  return request.post('/supplier/update', params, { json: true })
}

/**
 * @desc 查看详情
 * @params 列表row.id
 */
export const fetchDetails = params => {
  return request.get(`/supplier/${params}`, params)
}
